import Vue from "vue";

const state = {
  statuses: []
};

const getters = {};

const actions = {
  LOAD_PRODUCT_STATUSES: async function({ commit }) {
    await Vue.prototype.$axios.get("/product_status").then(res => {
      commit("SET_PRODUCT_STATUSES", res.data.productStatuses);
    });
  }
};

const mutations = {
  SET_PRODUCT_STATUSES: function(state, payload) {
    state.statuses = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
